import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { applicationRouteNames } from '../application-route-names';
import { ReportStore } from './report.store';

/**
 * Exige qu'un type de signalement soit choisi (sinon retour à report-type).
 */
export const reportTypeChosenGuard: CanActivateFn = () => {
  const store = inject(ReportStore);
  const router = inject(Router);
  return store.hasType() ? true : router.createUrlTree([applicationRouteNames.reportType]);
};

/**
 * Exige que les données de détail minimales soient saisies (sinon retour à report-detail).
 */
export const reportDataFilledGuard: CanActivateFn = () => {
  const store = inject(ReportStore);
  const router = inject(Router);
  return store.hasReportData() ? true : router.createUrlTree([applicationRouteNames.reportDetail]);
};
